import { render, staticRenderFns } from "./VQShort.vue?vue&type=template&id=7634bda9&scoped=true&"
import script from "./VQShort.vue?vue&type=script&lang=js&"
export * from "./VQShort.vue?vue&type=script&lang=js&"
import style0 from "./VQShort.vue?vue&type=style&index=0&id=7634bda9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7634bda9",
  null
  
)

export default component.exports